import styled from "styled-components";

export const TODetailsWrapper = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    cursor: default;
    box-sizing: border-box;
    flex-direction: column;
    text-wrap: nowrap;
    & > div {
        display: flex;
    }
    & > div:nth-child(1) {
        height: 20%;
    }
    & > div:nth-child(2) {
        height: 60%;
    }
    & > div:nth-child(3) {
        height: 20%;
    }
`
export const Overlay = styled.div<{$isOpen: boolean}>`
    position: absolute;
    top: 230px;
    height: 84px;
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-wrap: nowrap;
    //pointer-events: none;
    font-weight: 500;
    z-index: 1;
    width: 100%;
    color: white;
    //background: rgba(81, 220, 146, 0.05);
    // background: ${({ $isOpen }) => $isOpen ? '#5B71BF' : 'rgba(81, 220, 146, 0.05)'};
    background: #5B71BF;
    border-top: 4px solid rgba(122, 146, 248, 0.2);
    border-bottom: 4px solid rgba(122, 146, 248, 0.2);
    padding: 0 80px;
    box-sizing: border-box;
    
    @media (max-height: 940px) {
        height: 64px;  
        top: 182px;
        max-width: 390px;
        width: 390px;
        padding: 0 40px 0 26px;
        border-top: 3px solid rgba(122, 146, 248, 0.2);
        border-bottom: 3px solid rgba(122, 146, 248, 0.2);
        font-size: 16px;
    }
`
export const OverlayMarket = styled.div`
    width: 55%;
    height: 100%;
    //align-content: center;
    align-items: center;
    display: flex;
   overflow: hidden;
`

export const OverlayProfit = styled.div<{ $isOpen: boolean}>`
    width: 22.5%;
    align-content: center;
    color: ${({$isOpen}) => $isOpen ? 'white' : 'inherit' };
    height: ${({$isOpen}) => $isOpen ? '100%' : 'auto'};
    overflow: hidden;
`
export const OverlayTimestamp = styled.div<{ $isOpen: boolean }>`
    width: 22.5%;
    align-content: center;
    color: ${({$isOpen}) => $isOpen ? 'white' : '#5F83FF' };
    text-align: end;
    height: ${({$isOpen}) => $isOpen ? '100%' : 'auto'};
    overflow: hidden;
`

export const OverlayCustomScrollLine1 = styled.div`
    position: absolute;
    background: white;
    width: 4px;
    left: 37px;
    height: 22px;
    top: 28px;
    z-index: 2;
    @media (max-height: 940px) {
        width: 3px;
        left: 20px;
        top: 20px;
    }
`
export const OverlayCustomScrollLine2 = styled(OverlayCustomScrollLine1)`
    background: rgb(62 68 105);
    height: 90px;
    top: -4px;
    z-index: 1;
    @media (max-height: 940px) {
        left: 20px;
        height: 64px
    }
`
export const TOInfoTop = styled.div<{ isOpen: boolean }>`
    width: 543px;
    height: 247px;
    position: absolute;
    z-index: 3;
    //background: #2E2F36;
    display: ${({isOpen}) => isOpen ? 'flex' : 'none'};
    //top: 137px;
    top: -13px;
    box-sizing: border-box;
    padding: 42px 38px;
    flex-direction: column;
    overflow: hidden;
    @media(max-height: 940px) {
        width: 390px;
        height: 182px;
        //bottom: 110px;
        //top: 22px;
        top: 0;
        padding: 30px 26px;
    }
`
export const TOInfoBottom = styled(TOInfoTop)`
    top: 310px;
    @media (max-height: 940px) {
        top: 246px;
    }
`

export const ReturnBlock = styled.div`
    position: absolute;
    background: #1E1E1E;
    z-index: 1;
    width: 543px;
    display: flex;
    justify-content: center;
    //align-items: start;
    padding-top: 60px;
    height: calc(100vh - 718px);
    top: 556px;
    @media (max-height: 940px) {
        top: 428px;
        //height: calc(100vh - 538px);
        height: 100%;
        padding-top: 10px;
        width: 390px;
    }
`
export const ArrowWrapper = styled.div`
    z-index: 1;
    & > svg {
        //margin-bottom: 80px;
        cursor: pointer;
        @media (max-height: 940px) {
            //margin-bottom: 40px;
            padding-top: 70px;
            width: 56px;
            height: 56px;
        }
    }
`
export const ReturnHalo = styled.div`
    background: #7492FE;
    filter: blur(40px);
    height: 70px;
    width: 70px;
    position: absolute;
    z-index: 0;
    border: 1px solid rgba(0, 0, 0, 0);
    border-radius: 50%;
    //margin-bottom: 86px;
    @media (max-height: 940px) {
        //margin-bottom: 10px;
      margin-top: 70px;
        filter: blur(30px);
        width: 40px;
        height: 40px;
        //margin-bottom
    }
`
export const MoreInfoExchangeBlock = styled.div`
    //border-left: 1px solid red;
    font-size: 26px;
    display: flex;
    width: 100%;
    height: 26px;
    color: white;
    align-items: center;
    box-sizing: border-box;
    @media (max-height: 940px ) {
        font-size: 20px;
        height: 22px;
    }
    & > div:nth-child(1) {
        width: 30%;
        min-width: 120px;
    }
`
export const MoreInfoSide = styled.div<{isBuy: boolean}>`
    font-size: 13px;
    width: 73px;
    color: rgb(170, 170, 170);
    border: 1px solid ${({isBuy}) => isBuy ? 'rgba(0, 255, 0, 0.5)' : 'rgba(255, 0, 0, 0.5)'};
    border-radius: 4px;
  
    text-align: center;
    align-content: center;
    @media (max-height: 940px ) {
        //height: 20px;
        //margin-top: 0;
        width: fit-content;
        padding: 2px 6px;
        margin-left: 10px;
    }
`
export const Link = styled.div`
    width: 99px;
    height: 83px;
    background: #1E1E1E;
    border: 0;
    border-radius: 4px;
    color: #5B71BF;
    font-size: 17px;
    text-align: center;
    align-content: center;
    margin-right: 25px;
    margin-top: 14px;
    cursor: pointer;
    @media (max-height: 940px) {
        width: 66px;
        height: 54px;
        font-size: 13px;
        margin-right: 15px;
    }
`
export const MainMoreInfoBlock = styled.div`
    width: 100%;
    height: calc(100% - 30px);
    //border: 1px solid white;
    //padding: 20px 0;
    display: flex;
    justify-content: space-between;
    //border-left: 1px solid red;
    box-sizing: border-box;
    @media (max-height: 940px) {
        height: calc(100% - 22px);
    }
`
export const ExTOInfo = styled.div`
    display: flex;
    margin-top: 16px;
    flex-direction: column;
    font-size: 20px;
    color: white;
    @media (max-height: 940px) {
        margin-top: 12px;
        font-size: 14px;
    }

    & > div {
        margin-top: 14px;
        @media (max-height: 940px) {
            margin-top: 12px;
        }

    }
`
export const ExTOInfoNew = styled.div`
    display: flex;
    margin-top: 16px;
    flex-direction: column;
    font-size: 20px;
    color: white;
    @media (max-height: 940px) {
        margin-top: 12px;
        font-size: 14px;
    }

    & > div {
        margin-top: 14px;
        @media (max-height: 940px) {
            margin-top: 14px;
        }

    }
    
    & > div:nth-child(2) {
        margin-top: 34px;
        @media (max-height: 940px) {
            margin-top: 28px;
        }
    }
`
export const InfoRow = styled.div`
    display: flex;
    & > div:nth-child(1) {
        color: rgb(170, 170, 170);
    }
    & > div:nth-child(2) {
        margin-left: 8px;
    }
`

export const ExchangeIconImg = styled.div<{ src: string }>`
  //position: relative;
  margin-right: 8px;
    margin-top: 3px;
  height: 44px;
  width: 44px;
  //min-width: 32px;
  //min-height: 32px;
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
    cursor: pointer
`
export const MarketIconImg = styled(ExchangeIconImg)`
    height: 20px;
    width: 20px;
    margin-right: 0;
    margin-left: 12px;
`

export const DetailsTop = styled.div`
    justify-content: space-between;
    align-items: center;
    display: flex;
    width: 100%;
    height: 100%;
    & > div:nth-child(1) {
        width: 30%;
        height: 50px;
        border-radius: 14px;
        //border: 1px solid #ffffff10;
        padding-left: 10px;
        background: #ffffff05;
    }
    & > div:nth-child(2) {
        width: 30%;
    }
    & > div:nth-child(3) {
        width: 30%;
        height: 50px;
        border-radius: 14px;
        //border: 1px solid #ffffff10;
        padding-right: 10px;
        background: #ffffff05;
    }
`
export const DetailsBottom = styled(DetailsTop)``
export const DetailsPrice = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
`
export const DetailsPriceContainer = styled.div`
    height: 100%;
    display: flex;
    //align-items: center;
    flex-direction: column;
    justify-content: center;
`
export const DetailsPriceText = styled.div`
    color: #929AA5;
    font-size: 8px;
    position: absolute;
    bottom: 22px;
`
export const DetailsPriceNum = styled.div`
    color: white;
    font-size: 16px;
    height: 30px;
    align-items: center;
    display: flex;
    letter-spacing: -0.4px;
    position: relative;
`
export const DetailsSide = styled(DetailsPrice)`
    height: 100%;
    display: flex;
    justify-content: center;
`
export const DetailsSideInner = styled.div<{isSell: boolean}>`
    display: flex;
    height: 40px;
    color: ${({isSell}) => isSell ? '#FF5E66' : '#23AF91'};
    border: 1px solid ${({isSell}) => isSell ? '#FF5E6660' : '#23AF9160'};
    background: ${({isSell}) => isSell ? '#FF5E6610' : '#23AF9110'};
    font-size: 11px;
    align-items: center;
    justify-content: center;
    border-radius: 14px;
    width: 80px;
`

export const DetailsExchange = styled(DetailsPrice)`
    flex-direction: row;
    justify-content: end;
`
export const DetailsExchangeName = styled.div`
    display: flex;
    color: white;
    font-size: 12px;
    padding-right: 6px;
`
export const DetailsExchangeIcon = styled.div<{$src: string}>`
    width: 35px;
    height: 35px;
    //border-radius: 13px;
    background-repeat: no-repeat;
    background-position: center;
     background-image: ${({ $src }) => `url("${$src}")`};
    background-size: contain;
    cursor: default;
`

export const DetailsExchangeContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
    position: relative;
`

export const DetailsMarketWrapper = styled.div`
    display: flex;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #ffffff05;
    border: 1px solid #ffffff10;
`
export const DetailsMarketIcon = styled.div<{$src: string}>`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-position: center;
    background-image: ${({ $src }) => `url("${$src}")`};
    background-size: contain;
    cursor: pointer;
`
export const DetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 5% 0;
    background: #ffffff05;
    border-radius: 56px;
    box-sizing: border-box;
    text-wrap: nowrap;
`
export const DetailsCenter = styled.div`
    display: flex;
    width: 100%;
    height: 95%;
    & > div {
        text-align: end;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }
    //& > div:nth-child(1) {
    //    width: 28%;
    //    text-align: end;
    //}
    //& > div:nth-child(2) {
    //    width: 46%;
    //}
    //& > div:nth-child(3) {
    //    width: 28%;
    //    text-align: start;
    //}
    & > div:nth-child(1) {
        width: 35%;
        text-align: start;
    }
    & > div:nth-child(2) {
        width: 30%;
    }
    & > div:nth-child(3) {
        width: 35%;
        text-align: end;
    }
`
export const LeftCenterContainer = styled.div<{isFavorite: boolean}>`
    & > div {
        display: flex;
        flex-direction: column;
        height: 28%;
        width: 100%;
    }
    & > div:nth-child(1) {
        height: 16%;
        width: 100%;
        flex-direction: row;
        justify-content: center;
    }
    //& > div:nth-child(1) {
    //   
    //}
    //& > div:nth-child(2) {
    //    height:36px;
    //    align-content: center;
    //    font-size: 26px;
    //    color: white;
    //}
    //& > div:nth-child(3) {
    //    font-size: 12px;
    //    color: #ffffff30;
    //    padding-top: 10px;
    //}
    //& > div:nth-child(4) {
    //    font-size: 9px;
    //    color: #929AA5;
    //}
    //& > div:nth-child(5) {
    //    height: 70px;
    //    color: #23AF91;
    //    font-size: 16px;
    //    align-content: center;
    //}
    //& > div:nth-child(6) {
    //    font-size: 8px;
    //    color: #929AA5;
    //}
    //& > div:nth-child(7) {
    //    font-size: 12px;
    //    height: 70px;
    //    align-content: center;
    //    color: #ffffff30;
    //}
    //background: rgba(255, 0,0, 0.1);
`
export const CenterCenterContainer = styled.div`
    //background: rgba(0, 255, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    & > svg {
        stroke: #929AA5;
        width: 40px;
        height: 40px;
        &:active {
            transform: scale(0.95);
            stroke: #23AF91;
        }
    }
`
export const RightCenterContainer = styled.div<{isDeleted: boolean}>`
    & > div {
        display: flex;
        flex-direction: column;
        height: 28%;
        width: 100%;
    }
    & > div:nth-child(1) {
        height: 16%;
        width: 100%;
        flex-direction: row;
        justify-content: center;
    }
    //& > div:nth-child(2) {
    //    font-size: 9px;
    //    color: #ffffff30;
    //    height: 10px;
    //}
    //& > div:nth-child(3) {
    //    font-size: 19px;
    //    color: #23AF91;
    //    //height: 60px;
    //    //padding-top: 8px;
    //    align-content: center;
    //    text-wrap: nowrap;
    //}
    //& > div:nth-child(4) {
    //    font-size: 9px;
    //    color: #ffffff30;
    //}
    //& > div:nth-child(5) {
    //    height: 60px;
    //    //padding-top: 8px;
    //    align-content: center;
    //    color: white;
    //    font-size: 19px;
    //}
    //& > div:nth-child(6) {
    //    font-size: 9px;
    //    color: #ffffff30
    //}
    //& > div:nth-child(7) {
    //    height: 60px;
    //    //padding-top: 8px;
    //    align-content: center;
    //    color: white;
    //}
`
export const IconDetailsWrapperFav = styled.div<{isFavorite: boolean}>`
    height: 30px;
    cursor: pointer;
    width: 50%;
    justify-content: center;
    & > svg {
        fill: ${({isFavorite}) => isFavorite ? '#23AF91' : 'none' };
        stroke: ${({isFavorite}) => isFavorite ? '#23AF91' : '#929AA5' };
        width: 16px;
        height: 16px;
    }
`
export const IconDetailsWrapperDel = styled.div<{isDeleted: boolean}>`
    height: 10%;
    //text-align: center;
    cursor: pointer;
    //width: 100%;
    justify-content: center;
    & > svg {
        stroke: ${({isDeleted}) => isDeleted ? '#FF5E66' : '#929AA5' };
        width: 18px;
        height: 18px;
    }
`

export const ProfitPercentContainerRight = styled.div`
    & > span {
        font-size: 10px;
        color: #ffffff30;
        padding-right: 10px;
    }
    & > div {
        padding-right: 10px;
        margin-top: 2px;
        font-size: 19px;
        color: white;
        align-content: center;
        text-wrap: nowrap;
    }
`
export const ProfitPercentContainerLeft = styled.div`
    & > span {
        font-size: 10px;
        color: #ffffff30;
        padding-left: 10px;
    }
    & > div {
        padding-left: 10px;
        margin-top: 2px;
        font-size: 19px;
        color: white;
        align-content: center;
        text-wrap: nowrap;
    }
`
export const ProfitContainer = styled(ProfitPercentContainerRight)`
   & > div {
       color: #23AF91;
   } 
`
export const Info24Container = styled(ProfitPercentContainerLeft)`
    & > div {
        padding-left: 10px;
        padding-right: 0;
        color: #929AA5;
    }
    & > span {
        padding-left: 10px;
        padding-right: 0; 
    }
`
export const MarketContainer = styled(ProfitPercentContainerLeft)`
    & > div {
        font-size: 22px;
        text-wrap: nowrap;
        max-width: 100%;
        overflow: visible;
    }
    & > span {
        text-align: center;
    }
`

export const SelectedExchangeName = styled.div`
    font-size: 16px;
    text-align: center;
    color: #ffffff30;
`
export const DetailsTimePast = styled.div`
    width: 100%;
    justify-content: center;
    display: flex;
    align-items: center;
    color: #ffffff30;
    font-size: 12px;
    & > span {
        color: #929AA5;
        margin-left: 5px;
    }
`